import _ from 'lodash';
export default function (refiner) {
    const data = _.cloneDeep(refiner);
    if (!refiner.q) {
        delete data.q;
    }
    if (!refiner.efq) {
        delete data.efq;
    }
    if (!_.isString(refiner.efq)) {
        const pq = _.get(refiner, 'efq.pq', []);
        const wq = _.get(refiner, 'efq.wq', []);
        const efq = [].concat(pq).concat(wq);
        data.efq = efq.join(' AND ');
    }
    return data;
}
/**
 * 获取route折叠参数
 * @param {*} route
 * @returns
 */
export const getCollapseFromRoute = route => {
    try {
        const setting = _.get(route, 'query.setting');
        // eslint-disable-next-line prefer-const
        let { collapse, stem } = setting ? JSON.parse(setting) : { collapse: undefined, stem: undefined };
        // eslint-disable-next-line no-prototype-builtins
        if (collapse && !collapse.hasOwnProperty('field'))
            collapse = { field: 'ALL' };
        return {
            collapse,
            stem,
        };
    }
    catch (error) {
        console.info('Parse url collapse setting error', error);
    }
    return {};
};
